ixModuleRouting("impactx.condition", {
    "/conditionlist": {
        template: "<ixa-condition-list></ixa-condition-list>",
        templateUrl: "modules/condition/templates/conditionlist.html",
        process: "Condition",
        controller: "ConditionListController",
        controllerAs: "conditionListController",
        workspace: "content",
    },
    "/condition/:id": {
        template: "<ixa-condition-detail></ixa-condition-detail>",
        templateUrl: "modules/condition/templates/conditiondetail.html",
        controller: "ConditionDetailController",
        controllerAs: "conditionDetailController",
        process: "Condition",
    },
    "/dimensionconditionlist": {
        template: "<ixa-dimension-condition-list></ixa-dimension-condition-list>",
        process: "Condition",
        workspace: "content",
    },
    "/dimensioncondition/:id": {
        template: "<ixa-dimension-condition-dialog></ixa-dimension-condition-dialog>",
        templateUrl:
            "modules/condition/templates/dimensionconditiondetail.html",
        controller: "DimensionConditionDetailController",
        controllerAs: "conditionDetailController",
        process: "Condition",
    },
    "/condition/variablecosts/:cscId/:catId/:vcatId/:disId": {
        template: "<ixa-condition-variable-costs></ixa-condition-variable-costs>",
        process: "Condition",
    },
});
